import { IExtractedField } from 'types/db/ExtractedProForma';
import { AssumptionsMetricId } from '../../layout/metrics';
import { BlockResolver } from '../../layout/types';
import { buildFieldMap, extractedCell, hasDataWithPrefix } from './cells';

export const extractedAssumptionsResolver = (fields: IExtractedField[]): BlockResolver<AssumptionsMetricId> => {
    const fieldMap = buildFieldMap(fields);

    return {
        hasData: () => hasDataWithPrefix(fieldMap, 'assumptions.'),

        effectiveRentPerSf: extractedCell(fieldMap, 'assumptions.effective_rent_per_sf_per_month'),
        effectiveRentPerUnit: extractedCell(fieldMap, 'assumptions.effective_rent_per_unit_per_month'),
        rentalIncomeGrowth: extractedCell(fieldMap, 'assumptions.rental_income_annual_growth'),
        expensesGrowth: extractedCell(fieldMap, 'assumptions.expenses_annual_growth'),
        generalVacancy: extractedCell(fieldMap, 'assumptions.general_vacancy'),
        creditLoss: extractedCell(fieldMap, 'assumptions.credit_loss'),
    };
};
